export default __webpack_public_path__ + "static/media/london.451008d4.jpg";